<template>
  <div class="balance-history-container" ref="">
    <back />
    <b-form v-show="true" @submit.prevent="search" class="sticky-top">
      <b-row class="d-flex justify-content-md-end justify-content-sm-center mx-2">
        <b-col class="col-md-4 col-sm-12">
          <b-form-group label="Хугацаа">
            <b-input-group>
              <b-form-datepicker
                  :dark="true"
                  reset-button
                  reset-value="''"
                  label-reset-button="Цэвэрлэх"
                  reset-button-variant="outline-primary"
                  placeholder="Эхлэх огноо"
                  v-model="filters.from"
              />
              <b-form-datepicker
                  :dark="true"
                  reset-button
                  reset-value="''"
                  label-reset-button="Цэвэрлэх"
                  reset-button-variant="outline-primary"
                  placeholder="Дуусах огноо"
                  v-model="filters.to"
              />
              <b-input-group-append>
                <b-button type="submit" variant="success" class="card-button mt-0">Хайх</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
    </b-form>
    <b-table-simple class="statement_table" small striped outlined>
      <b-thead>
        <b-th>№</b-th>
        <b-th>date</b-th>
        <b-th>debit</b-th>
        <b-th>credit</b-th>
        <b-th>quantity</b-th>
        <b-th>unitPrice</b-th>
        <b-th>fee</b-th>
        <b-th>description</b-th>
      </b-thead>
      <b-tbody>
        <b-tr v-for="(item, i) in items" :key="i">
          <b-th>{{ i + 1 }}</b-th>
          <b-th>{{ item.bgyg }}</b-th>
          <span v-if="item.cDef && item.cDef.toString() === '30'">
            <b-th>{{ item.c_Debit }}</b-th>
            <b-th>{{ '-' }}</b-th>
          </span>
          <span v-else-if="item.cDef && item.cDef.toString() === '20'">
            <b-th>{{ '-' }}</b-th>
            <b-th>{{ item.c_Debit }}</b-th>
          </span>
          <b-th>{{ item.cShareQty }}</b-th>
          <b-th>{{ item.cPerPrice }}</b-th>
          <b-th>{{ item.cFee }}</b-th>
          <b-th>{{ item.cDesc }}</b-th>
        </b-tr>
      </b-tbody>
    </b-table-simple>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import _ from 'lodash';
import api from '../api/balance';
import back from '../components/BackButton';

export default {
  name: 'MSEBalanceHistoryDetail',
  data() {
    return {
      isLoading: false,
      filters: {
        from: moment().format('YYYY-MM-DD'),
        to: moment().format('YYYY-MM-DD'),
      },
      items: [],
    };
  },
  components: {
    back,
  },
  mounted() {
    this.fetchData();
  },
  computed: {
    ...mapState('common', ['dark']),
  },
  methods: {
    async fetchData() {
      this.isLoading = true;
      try {
        const { data } = api.getTransactions(this.queryHandler(), 'att');
        this.items = [ ...data ];
      } catch (e) {
        console.error(e);
      }
      this.isLoading = false;
    },
    search() {
      const query = _.pickBy(this.filters, v => (!_.isEmpty(v) || !!v));
      this.$router.push({ query });
    },
    queryHandler() {
      this.filters = { ...this.filters, ...this.$route.query };
      return _.pickBy(this.filters, v => (!_.isEmpty(v) || !!v));
    },
  }
}
</script>
<style scoped>
  .balance-history-container {
    /*border: 1px green solid;*/
    width: calc(100vw - 80px) !important;
    overflow-y: scroll;
  }
  .search-form {
    background-color: #fff;
    z-index: 2;
  }
</style>
